import React from "react";
import ChicaHead from "../../img/chica-head-mb@2x.png";
import ChicaHeadDesk from "../../img/chica-head-desktop@2x.png";
import "../../components/header/header.css";

const Header = () => {
  return (
    <div className="move">
      <div className="containerChicaLogo">
        <div className="imgChica">
          <img src={ChicaHead} alt="" />
        </div>
        <div className="imgChicaDesk">
          <img src={ChicaHeadDesk} alt="" />
        </div>
        <div className="logoElectroMov">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="663.529"
            height="181.852"
            viewBox="0 0 663.529 181.852"
          >
            <g
              id="Grupo_41"
              data-name="Grupo 41"
              transform="translate(-180.145 -232.57)"
            >
              <path
                id="Trazado_73"
                data-name="Trazado 73"
                d="M220.652,282.38c-5.352,0-9,4.214-10.135,10.477H229.99C230.1,286.708,226.233,282.38,220.652,282.38Z"
                transform="translate(-7.597 -12.459)"
                fill="none"
              />
              <path
                id="Trazado_74"
                data-name="Trazado 74"
                d="M364.009,282.38c-5.352,0-9,4.214-10.135,10.477h19.473C373.461,286.708,369.59,282.38,364.009,282.38Z"
                transform="translate(-43.454 -12.459)"
                fill="none"
              />
              <path
                id="Trazado_75"
                data-name="Trazado 75"
                d="M213.511,325.119c11.729,0,21.067-3.986,27.558-11.16l-11.957-11.73c-4.1,3.758-8.769,5.922-13.666,5.922-5.922,0-10.249-3.3-12.071-9.224h41.679c1.366-22.776-10.477-37.353-32.228-37.353-19.587,0-32.682,12.641-32.682,32C180.145,312.593,192.786,325.119,213.511,325.119Zm-.456-47.943c5.581,0,9.451,4.328,9.337,10.477H202.92C204.059,281.39,207.7,277.176,213.055,277.176Z"
                transform="translate(0 -7.255)"
                fill="#fecd0c"
              />
              <rect
                id="Rectángulo_40"
                data-name="Rectángulo 40"
                width="23.003"
                height="84.497"
                transform="translate(254.849 232.57)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_76"
                data-name="Trazado 76"
                d="M356.868,325.119c11.729,0,21.067-3.986,27.558-11.16l-11.957-11.73c-4.1,3.758-8.769,5.922-13.666,5.922-5.922,0-10.249-3.3-12.071-9.224h41.679c1.366-22.776-10.477-37.353-32.228-37.353-19.587,0-32.682,12.641-32.682,32C323.5,312.593,336.143,325.119,356.868,325.119Zm-.456-47.943c5.581,0,9.451,4.328,9.338,10.477H346.277C347.416,281.39,351.061,277.176,356.412,277.176Z"
                transform="translate(-35.857 -7.255)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_77"
                data-name="Trazado 77"
                d="M448.214,325.119c13.665,0,24.142-5.808,28.925-16.057l-17.878-9c-1.937,4.67-5.353,6.834-9.794,6.834-6.149,0-10.249-5.353-10.249-13.438,0-7.857,4.1-13.209,10.249-13.209,4.328,0,7.743,2.277,9.907,6.149l17.651-8.654c-5.239-10.249-15.6-16.172-28.583-16.172-19.587,0-32.456,12.755-32.456,32C415.986,312.593,428.741,325.119,448.214,325.119Z"
                transform="translate(-58.99 -7.255)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_78"
                data-name="Trazado 78"
                d="M537.091,302.948c-3.189,0-5.239-1.935-5.239-5.921V275.846h15.259V261.155H531.852v-17.2H508.963v17.2h-8.541v14.691h8.541v24.711c0,12.869,8.881,20.5,22.092,20.385,6.263,0,17.518-3.21,21.845-5.716l-.263-16.928C549.9,299.322,538.912,302.948,537.091,302.948Z"
                transform="translate(-80.11 -2.849)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_79"
                data-name="Trazado 79"
                d="M618.373,261.424a22.162,22.162,0,0,0-19.473,10.7v-9.792h-23v61.949h6.45A16.554,16.554,0,0,0,598.9,307.731V294.676c0-9,7.63-14.007,19.473-12.527Z"
                transform="translate(-98.988 -7.217)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_80"
                data-name="Trazado 80"
                d="M715.161,272.193c.193.216.377.439.563.66C715.537,272.632,715.354,272.409,715.161,272.193Z"
                transform="translate(-133.822 -9.911)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_81"
                data-name="Trazado 81"
                d="M726.047,291.786c.073.352.141.707.2,1.064C726.188,292.493,726.12,292.138,726.047,291.786Z"
                transform="translate(-136.544 -14.811)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_82"
                data-name="Trazado 82"
                d="M725.464,289.337c.093.343.179.688.261,1.035C725.643,290.025,725.557,289.68,725.464,289.337Z"
                transform="translate(-136.399 -14.199)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_83"
                data-name="Trazado 83"
                d="M717.735,274.058c.187.236.366.48.547.721C718.1,274.537,717.922,274.294,717.735,274.058Z"
                transform="translate(-134.465 -10.377)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_84"
                data-name="Trazado 84"
                d="M711.7,268.744c.188.167.367.344.552.516C712.07,269.088,711.891,268.911,711.7,268.744Z"
                transform="translate(-132.957 -9.048)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_85"
                data-name="Trazado 85"
                d="M709.829,267.172c.162.127.315.265.474.4C710.144,267.437,709.991,267.3,709.829,267.172Z"
                transform="translate(-132.488 -8.655)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_86"
                data-name="Trazado 86"
                d="M719.2,276.013c.179.253.349.514.521.773C719.549,276.527,719.379,276.266,719.2,276.013Z"
                transform="translate(-134.832 -10.866)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_87"
                data-name="Trazado 87"
                d="M713.483,270.42c.194.193.377.394.565.592C713.86,270.814,713.677,270.613,713.483,270.42Z"
                transform="translate(-133.402 -9.467)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_88"
                data-name="Trazado 88"
                d="M726.776,296.839c.031.37.058.739.076,1.112C726.834,297.578,726.807,297.209,726.776,296.839Z"
                transform="translate(-136.727 -16.075)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_89"
                data-name="Trazado 89"
                d="M724.742,286.947c.111.331.215.665.316,1C724.957,287.612,724.853,287.278,724.742,286.947Z"
                transform="translate(-136.218 -13.601)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_90"
                data-name="Trazado 90"
                d="M680.1,330.352a31.761,31.761,0,0,0,31.762-31.762c0-.446-.023-.887-.041-1.329a4.725,4.725,0,0,0-4.74-4.136H694.738a2.373,2.373,0,0,1,1.941,3.737s-8.934,12.948-14.092,21.678a24.89,24.89,0,0,1-4.9,6.2h0c-.234.2-.48.4-.727.585-.122.093-.247.182-.374.271-.243.174-.488.345-.744.5-.132.081-.273.151-.409.227-.208.117-.414.237-.63.342-.154.076-.316.138-.474.207-.209.091-.417.183-.633.262-.17.061-.347.111-.523.164-.216.067-.432.134-.655.187-.184.044-.374.077-.563.112-.226.042-.454.083-.688.11-.2.024-.4.037-.6.05-.239.016-.481.026-.727.027-.209,0-.422-.008-.636-.02-.137-.007-.267,0-.406-.012-.1-.008-.2-.034-.3-.046-.325-.035-.658-.089-1-.152-.143-.026-.275-.036-.421-.064-.07-.014-.153-.044-.229-.065-.1-.024-.2-.034-.3-.06A31.621,31.621,0,0,0,680.1,330.352Z"
                transform="translate(-121.691 -15.146)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_91"
                data-name="Trazado 91"
                d="M722.9,282.357c.144.3.28.613.414.922C723.178,282.97,723.042,282.661,722.9,282.357Z"
                transform="translate(-135.757 -12.453)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_92"
                data-name="Trazado 92"
                d="M723.885,284.619c.128.318.249.64.367.963C724.134,285.259,724.013,284.937,723.885,284.619Z"
                transform="translate(-136.004 -13.019)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_93"
                data-name="Trazado 93"
                d="M721.786,280.167c.157.288.306.582.454.875C722.092,280.749,721.943,280.455,721.786,280.167Z"
                transform="translate(-135.479 -11.905)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_94"
                data-name="Trazado 94"
                d="M726.486,294.288c.052.362.1.725.14,1.091C726.586,295.013,726.538,294.65,726.486,294.288Z"
                transform="translate(-136.654 -15.437)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_95"
                data-name="Trazado 95"
                d="M720.553,278.052c.169.271.328.547.489.823C720.881,278.6,720.722,278.323,720.553,278.052Z"
                transform="translate(-135.17 -11.376)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_96"
                data-name="Trazado 96"
                d="M662.5,327.451c.239.026.475.047.707.059.215.011.427.019.636.019.246,0,.487-.012.727-.027.2-.013.4-.026.6-.05.234-.028.461-.068.688-.11.189-.035.379-.068.563-.112.224-.054.439-.121.655-.187.175-.053.352-.1.523-.164.216-.079.424-.171.633-.262.158-.069.32-.131.474-.207.216-.1.422-.225.63-.342.136-.077.277-.146.409-.227.256-.157.5-.328.744-.5.126-.089.251-.178.373-.271.247-.189.491-.382.725-.585-1.444-.055-.893-3.8-.893-3.8l2.665-15.7c.282-1.929.349-3.079-2.979-3.019h-18.4s-10.438,1.1-9.126-9.872a31.756,31.756,0,0,0,13.6,32.711,20.475,20.475,0,0,0,4.4,2.371c.22.052.434.09.649.13C661.838,327.36,662.171,327.414,662.5,327.451Z"
                transform="translate(-115.58 -14.887)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_97"
                data-name="Trazado 97"
                d="M652.144,294.4H662.78a3.457,3.457,0,0,1-2.961-4.39l6.525-22.813c1.5-5.341-3.638-6.549-7.717-4.127a32.564,32.564,0,0,0-15.609,21.459v0C641.706,295.508,652.144,294.4,652.144,294.4Z"
                transform="translate(-115.748 -7.331)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_98"
                data-name="Trazado 98"
                d="M719.9,277.044c.167.25.334.5.493.756C720.229,277.544,720.062,277.294,719.9,277.044Z"
                transform="translate(-135.006 -11.124)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_99"
                data-name="Trazado 99"
                d="M716.912,273.073c.207.245.417.488.617.739C717.329,273.56,717.12,273.318,716.912,273.073Z"
                transform="translate(-134.259 -10.131)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_100"
                data-name="Trazado 100"
                d="M722.392,281.334c.129.255.258.509.379.767C722.65,281.843,722.521,281.589,722.392,281.334Z"
                transform="translate(-135.63 -12.197)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_101"
                data-name="Trazado 101"
                d="M718.465,275.019c.185.247.373.493.551.745C718.838,275.512,718.65,275.266,718.465,275.019Z"
                transform="translate(-134.648 -10.618)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_102"
                data-name="Trazado 102"
                d="M721.2,279.15c.148.253.3.505.436.763C721.5,279.655,721.352,279.4,721.2,279.15Z"
                transform="translate(-135.333 -11.651)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_103"
                data-name="Trazado 103"
                d="M726.316,293.2c.047.269.088.541.128.812C726.4,293.746,726.362,293.474,726.316,293.2Z"
                transform="translate(-136.612 -15.166)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_104"
                data-name="Trazado 104"
                d="M723.45,283.587c.111.256.221.514.326.774C723.671,284.1,723.561,283.843,723.45,283.587Z"
                transform="translate(-135.895 -12.761)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_105"
                data-name="Trazado 105"
                d="M724.374,285.9c.094.259.187.52.276.783C724.561,286.423,724.468,286.163,724.374,285.9Z"
                transform="translate(-136.126 -13.34)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_106"
                data-name="Trazado 106"
                d="M725.163,288.282q.117.394.226.791Q725.281,288.675,725.163,288.282Z"
                transform="translate(-136.323 -13.935)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_107"
                data-name="Trazado 107"
                d="M714.237,271.209c.232.244.468.487.693.738C714.7,271.7,714.469,271.453,714.237,271.209Z"
                transform="translate(-133.59 -9.665)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_108"
                data-name="Trazado 108"
                d="M725.812,290.717q.093.4.176.8Q725.905,291.116,725.812,290.717Z"
                transform="translate(-136.486 -14.544)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_109"
                data-name="Trazado 109"
                d="M726.9,298.629c0-.1-.016-.2-.021-.307,0,.079,0,.16.008.239C726.888,298.584,726.9,298.605,726.9,298.629Z"
                transform="translate(-136.752 -16.446)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_110"
                data-name="Trazado 110"
                d="M726.673,295.743c.03.272.054.547.077.822C726.727,296.29,726.7,296.016,726.673,295.743Z"
                transform="translate(-136.701 -15.801)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_111"
                data-name="Trazado 111"
                d="M712.439,269.432c.263.245.529.487.783.741C712.968,269.919,712.7,269.677,712.439,269.432Z"
                transform="translate(-133.141 -9.22)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_112"
                data-name="Trazado 112"
                d="M707.863,265.706q.754.529,1.474,1.1Q708.616,266.235,707.863,265.706Z"
                transform="translate(-131.996 -8.288)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_113"
                data-name="Trazado 113"
                d="M710.461,267.7c.314.257.628.514.931.783C711.089,268.214,710.774,267.958,710.461,267.7Z"
                transform="translate(-132.646 -8.787)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_114"
                data-name="Trazado 114"
                d="M717.02,289.842c0-.079,0-.16-.007-.239-.018-.373-.046-.742-.077-1.112-.023-.274-.047-.55-.077-.822-.04-.366-.088-.729-.14-1.091-.04-.271-.081-.543-.128-.812-.061-.357-.129-.712-.2-1.064q-.083-.4-.176-.8c-.082-.347-.168-.692-.261-1.035q-.108-.4-.226-.791c-.1-.336-.2-.67-.316-1-.089-.262-.182-.523-.276-.783-.118-.323-.238-.645-.367-.963-.105-.26-.215-.517-.326-.774-.134-.31-.27-.618-.414-.922-.121-.258-.25-.512-.379-.767-.148-.293-.3-.587-.454-.875-.14-.257-.288-.51-.436-.763-.16-.276-.32-.553-.489-.823s-.327-.505-.493-.756-.342-.52-.521-.773-.366-.5-.551-.745-.36-.484-.547-.721-.41-.493-.617-.739c-.187-.22-.37-.444-.563-.66-.225-.251-.46-.493-.693-.738-.188-.2-.372-.4-.565-.592-.254-.253-.52-.5-.783-.741-.185-.172-.364-.349-.552-.516-.3-.269-.618-.526-.931-.783-.159-.131-.312-.268-.474-.4q-.721-.57-1.474-1.1c-3.635-2.546-9.157-2.822-11.052,3.605l-4.89,14.864a1.493,1.493,0,0,0,1.369,2.091H712.28A4.725,4.725,0,0,1,717.02,289.842Z"
                transform="translate(-126.886 -7.727)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_115"
                data-name="Trazado 115"
                d="M411.874,414.79v38.439H389.368V421.252c0-6.016-3.343-9.8-8.357-9.8-5.794.112-9.471,4.9-9.471,11.81v29.972H349.034V421.252c0-6.016-3.343-9.8-8.357-9.8-5.9.112-9.582,4.9-9.582,11.81v28.557H310V394.031H331.1v7.834c4.123-6.573,10.585-10.139,18.829-10.139,9.471,0,16.713,4.9,19.944,13.147,3.9-8.468,11.03-13.147,20.5-13.147C403.183,391.726,411.874,400.752,411.874,414.79Z"
                transform="translate(-32.481 -39.809)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_116"
                data-name="Trazado 116"
                d="M522.9,422.961c0,18.718-13.259,31.087-33.648,31.087s-33.76-12.368-33.76-31.087c0-18.829,13.37-31.085,33.76-31.085S522.9,404.132,522.9,422.961Zm-44.679.224c0,8.133,4.345,13.481,11.031,13.481,6.573,0,10.918-5.347,10.918-13.481,0-8.024-4.345-13.483-10.918-13.483C482.57,409.7,478.225,415.161,478.225,423.185Z"
                transform="translate(-68.873 -39.847)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_117"
                data-name="Trazado 117"
                d="M567.143,453.526l-22.507-60.612h23.176l11.142,40.111,11.026-36.7h21.214l-21.1,57.2Z"
                transform="translate(-91.169 -40.106)"
                fill="#e8b30c"
              />
              <circle
                id="Elipse_3"
                data-name="Elipse 3"
                cx="11.588"
                cy="11.588"
                r="11.588"
                transform="translate(527.108 323.951)"
                fill="#fecd0c"
              />
              <rect
                id="Rectángulo_41"
                data-name="Rectángulo 41"
                width="22.506"
                height="60.612"
                transform="translate(527.331 352.808)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_118"
                data-name="Trazado 118"
                d="M692.016,446.168V363.495h22.506v82.673Z"
                transform="translate(-128.032 -32.748)"
                fill="#e8b30c"
              />
              <circle
                id="Elipse_4"
                data-name="Elipse 4"
                cx="11.588"
                cy="11.588"
                r="11.588"
                transform="translate(600.523 323.951)"
                fill="#fecd0c"
              />
              <rect
                id="Rectángulo_42"
                data-name="Rectángulo 42"
                width="22.506"
                height="60.612"
                transform="translate(600.746 352.808)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_119"
                data-name="Trazado 119"
                d="M850.12,444.124H827.613v-4.864a20.739,20.739,0,0,1-16.6,7.689c-16.935,0-28.077-12.368-28.077-31.421,0-18.606,10.919-30.75,27.52-30.75a21.459,21.459,0,0,1,17.157,7.8V373.411l22.507-9.916Zm-22.507-28.038c0-8.024-4.345-13.483-10.919-13.483-6.684,0-11.03,5.459-11.03,13.483,0,8.133,4.346,13.593,11.03,13.593C823.269,429.679,827.613,424.219,827.613,416.086Z"
                transform="translate(-150.774 -32.748)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_120"
                data-name="Trazado 120"
                d="M1042.514,446.952h-22.507v-7.693a20.742,20.742,0,0,1-16.6,7.689c-16.935,0-28.077-12.368-28.077-31.421,0-18.606,10.919-30.75,27.52-30.75a21.462,21.462,0,0,1,17.158,7.8V380.482l22.507-16.987Zm-22.507-30.866c0-8.024-4.346-13.483-10.92-13.483-6.684,0-11.029,5.459-11.029,13.483,0,8.133,4.345,13.593,11.029,13.593C1015.662,429.679,1020.007,424.219,1020.007,416.086Z"
                transform="translate(-198.896 -32.748)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_121"
                data-name="Trazado 121"
                d="M1034.824,446.957V375.129a11.614,11.614,0,0,1,11.614-11.614h11.014v83.442Z"
                transform="translate(-213.778 -32.753)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_122"
                data-name="Trazado 122"
                d="M865.369,445.543V363.515H854.355c-6.414,0-11.614,4.57-11.614,10.207v71.821"
                transform="translate(-165.733 -32.753)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_123"
                data-name="Trazado 123"
                d="M913.527,445.55c0,3.788,2.451,6.016,6.8,6.016a11,11,0,0,0,10.251-6.239v-5.459H920.324C915.867,439.868,913.527,441.761,913.527,445.55Z"
                transform="translate(-183.438 -51.851)"
                fill="none"
              />
              <path
                id="Trazado_124"
                data-name="Trazado 124"
                d="M923.513,424.973v.138H908.695c-15.266.223-23.4,6.686-23.4,18.384,0,11.366,7.577,19.053,20.5,19.053,8.021,0,14.039-2.786,17.716-7.687v6.054h.586V425.559Zm0,16.628a11,11,0,0,1-10.251,6.239c-4.346,0-6.8-2.228-6.8-6.016s2.34-5.682,6.8-5.682h10.251Z"
                transform="translate(-176.377 -48.125)"
                fill="#e8b30c"
              />
              <path
                id="Trazado_125"
                data-name="Trazado 125"
                d="M946.875,413.9c0-14.039-10.139-22.173-27.186-22.173-9.471,0-19.276,2.229-29.192,6.24l5.572,14.93c6.684-2.9,13.481-4.346,18.272-4.346,6.907,0,10.473,3.008,10.473,8.022V452.6h.586v.63h21.475Z"
                transform="translate(-177.678 -39.809)"
                fill="#fecd0c"
              />
              <path
                id="Trazado_126"
                data-name="Trazado 126"
                d="M599.6,393.692l-16.5,60.029h16.5l22.628-60.029Z"
                transform="translate(-100.79 -40.301)"
                fill="#fecd0c"
              />
              <rect
                id="Rectángulo_43"
                data-name="Rectángulo 43"
                width="22.628"
                height="60.814"
                transform="translate(276.77 353.391)"
                fill="#fecd0c"
              />
            </g>
          </svg>
        </div>
      </div>
      <div className="muevete">
        <p className="white"> ¡MUÉVETE</p>
        <p className="yellow">&nbsp; SUSTENTABLE! </p>
      </div>
      <br />
      <br />
      <div className="btnElectro">
        <p>VER TODO EN ELECTROMOVILIDAD</p>
      </div>
    </div>
  );
};

export default Header;
